/**
 * The Google tag, so a Google ad click can be counted as a conversion when the
 * visitor then taps "Get the app".
 *
 * Off until the owner sets REACT_APP_GOOGLE_ADS_ID (the `AW-…` id from Google
 * Ads) and REACT_APP_GOOGLE_ADS_LABEL (the conversion's label). Like the Meta
 * Pixel, it runs on the marketing site only; the console never loads it.
 *
 * Nothing about a gym, its members or a signed-in owner is sent from here.
 */
const adsId = (process.env.REACT_APP_GOOGLE_ADS_ID || "").trim();
const conversionLabel = (process.env.REACT_APP_GOOGLE_ADS_LABEL || "").trim();

const LIVE_HOSTS = ["varzishmate.com", "www.varzishmate.com"];

export const googleAdsEnabled = () => Boolean(adsId);

export const initGoogleAds = (win = typeof window === "undefined" ? null : window) => {
  if (!adsId || !win) return;
  // The prerender's headless browser is not a visitor.
  if (win.navigator.webdriver) return;
  if (!LIVE_HOSTS.includes(win.location.hostname)) return;
  if (win.gtag) return;

  win.dataLayer = win.dataLayer || [];
  // gtag.js reads `arguments` objects from dataLayer, so this must not be an
  // arrow function or a rest-args wrapper.
  win.gtag = function gtag() {
    win.dataLayer.push(arguments); // eslint-disable-line prefer-rest-params
  };
  win.gtag("js", new Date());
  win.gtag("config", adsId);

  const script = win.document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(adsId)}`;
  script.fetchPriority = "low";
  win.document.head.appendChild(script);
};

/** The "Get app click" conversion. Best effort: tracking must never break a click. */
export const trackGoogleConversion = () => {
  try {
    if (!adsId || !conversionLabel || typeof window === "undefined" || !window.gtag) return;
    window.gtag("event", "conversion", { send_to: `${adsId}/${conversionLabel}` });
  } catch {
    /* swallow */
  }
};
